import { messages } from '@/texts/messages'
import FormService from '@/services/FormService'

export default class CreateStrategy {
  constructor() {
    this.service = new FormService()
  }

  async save(token, form) {
    return await this.service.submit(token, form)
  }

  async init(store, formId, token) {}

  getFormTitle() {
    return messages.title_new_form_create
  }

  getSubmitButtonText() {
    return messages.submission_new_call
  }

  submitCallback(component) {
    return () => {
      location.hash = ''
      component.$router.go()
    }
  }
}
